module.exports = __webpack_public_path__ + "static/ideaport-web-80ac188d141274fafc027c0e016979c3.jpg";